















import { namespace } from 'vuex-class'
import { Vue, Component } from 'vue-property-decorator'

const accountStore = namespace('account')

@Component({})

export default class LogoutButton extends Vue {
  paquito = ''

  @accountStore.Action
  public removeUser!: () => void

  onLogoutButtonClicked (): void {
    this.removeUser()
    this.$router.push({ name: 'Error403' })
    this.$emit('logout-button-clicked')
  }
}
